import Util from 'lib/util.js';
import Http from 'services/http2';
import Storage from 'services/storage2';
import { UserResponse } from 'interface/response';

/**
 * 公众号或企业微信跳转地址
 *
 * 微信端地址: 'https://dev.xiekeyun.com/mp/purchase/order/detail/91904378/1016403408456163'
 * redirect_url: 'https%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fpurchase%2Forder%2Fdetail%2F91904378%2F1016403408456163'
 *
 * `https://open.weixin.qq.com/connect/oauth2/authorize?appid={$appid}&redirect_uri={$redirect_uri}&response_type=code&scope={$scope}&state={$state}#wechat_redirect`
 *
 * 公众号：
 * appid: 'wx69332f4727b14d05'  //开发环境 'wxf3cf604fbe16e419'
 * scope: 'snsapi_base'
 * stat: 'weChat'
 *
 * 跳转地址:
 * https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=https%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fpurchase%2Forder%2Fdetail%2F91904378%2F1016403408456163&response_type=code&scope=snsapi_base&state=weChat#wechat_redirect
 *
 * 企业微信：
 * appid: 'wwd720f40a6340eedd'
 * scope: 'snsapi_userinfo'
 * stat: 'weWork'
 *
 * 跳转地址:
 * https://open.weixin.qq.com/connect/oauth2/authorize?appid=wwd720f40a6340eedd&redirect_uri=https%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fpurchase%2Forder%2Fdetail%2F91904378%2F1016403408456163&response_type=code&scope=snsapi_userinfo&state=weWork#wechat_redirect
 *
 * 调试地址：https://dev.xiekeyun.com/mp/purchase/order/detail/91904378/1016403408456163?code=123&state=weWork
 *
 *
 * https://open.weixin.qq.com/connect/oauth2/authorize?appid=wwd720f40a6340eedd&redirect_uri=http%3A%2F%2Fconsole.xiekeyun.com%2Fmp%2Fsale%2Fdelivery%2Flist&response_type=code&scope=snsapi_userinfo&state=weWork#wechat_redirect
 *
 */

let userInfo = Storage.getItem('userInfo') || {};
let companyList: any[] = Storage.getItem('companyList') || [];
let companyCode = Storage.getItem('companyCode'); //默认公司代码
let defaultCompany: any = {};
let authCodeList = Storage.getItem('authCodeList') || []; //权限列表，用于控制按钮权限
let appName = Storage.getItem('appName') || 'mp'; // 当前应用。mp|weWork|dingTalk

const User = {
  initDefaultCompany() {
    //默认公司不在公司列表中时，使用 defaultFlag === 1 的公司做为默认
    if (
      (companyCode === null ||
        this.getCompanyInfo(companyCode) === undefined) &&
      companyList.length > 0
    ) {
      for (let company of companyList) {
        if (company.defaultFlag === 1) {
          companyCode = company.companyCode;
          defaultCompany = company;
          Storage.setItem('companyCode', companyCode);
          break;
        }
      }
      //如果还没有匹配，使用公司列表中的第一家公司作为默认公司
      if (!defaultCompany.companyCode) {
        let company = companyList[0];
        companyCode = company.companyCode;
        defaultCompany = company;
        Storage.setItem('companyCode', companyCode);
      }
    }
    //检查IP登录限制
    this.checkIpLimit(companyCode);
  },

  getCompanyCode() {
    return companyCode;
  },

  setCompanyCode(code) {
    companyCode = code;
    companyList.some(company => {
      let rs = company.companyCode === code;
      if (rs) {
        defaultCompany = company;
      }
      return rs;
    });
    Storage.setItem('companyCode', code);
    this.getMenuAuth();
  },

  getAppName() {
    return appName;
  },

  setAppName(name) {
    appName = name;
    Storage.setItem('appName', name);
  },

  getCompanyInfo(code) {
    let sCompanyCode = code || companyCode;
    let info;
    for (let company of companyList) {
      if (sCompanyCode === company.companyCode) {
        info = { ...company };
        break;
      }
    }
    return info;
  },

  setDefaultCompany() {},

  getDefaultCompanyCode() {
    if (defaultCompany !== undefined && defaultCompany.companyCode) {
      companyCode = defaultCompany.companyCode;
    }
    return companyCode;
  },

  getDefaultCompany() {
    return defaultCompany;
  },

  setCompanyList(arr) {
    if (Array.isArray(arr)) {
      companyList = arr;
      Storage.setItem('companyList', arr);
    }
  },

  getCompanyList() {
    return companyList;
  },

  //初始化用户和公司列表，每个页面必须先用此方法初始化
  async init(routeCompanyCode?) {
    let { code, state } = Util.getParamObj(window.location.search);
    let data: any = {
      success: false,
      errorCode: '0001',
      errorMsg: '无法确定用户身份'
    };

    if (userInfo.id !== undefined) {
      //已登录
      data = { success: true };
      //检查IP登录限制
      await this.checkIpLimit(routeCompanyCode || companyCode);
    } else if (code !== undefined) {
      if (state === 'weWork') {
        //企业微信
        return await this.weWorkInit(code, routeCompanyCode);
      }

      //微信auth code
      await Http.post('/api/mp', { apiPath: '/login', code, state }).then(
        response => {
          if (response.success) {
            this.setUserInfo(response.data.sysUser);
            this.setCompanyList(response.data.companyList);
            companyList = response.data.companyList;
            if (routeCompanyCode) {
              companyCode = routeCompanyCode;
              this.setCompanyCode(companyCode);
            }
            this.initDefaultCompany();
            data = response;
          } else {
            /**
             * 500 系统异常
             * 700 参数异常
             * 100002 该wxOpenId的用户不存在
             */
            if (response.errorCode === '100002') {
              data.errorMsg =
                '您的微信还未与任何携客账号绑定，请先登录携客云绑定微信。';
            } else {
              data.errorMsg = '无法确定用户身份，请退出重试。';
            }
          }
        }
      );
      if (companyList.length > 0) {
        await this.getMenuAuth();
      }
    }
    if (companyCode === undefined) {
      data = { success: false, errorCode: '0002', errorMsg: '用户无默认公司' };
    }

    return data;
  },

  //企业微信初始化登录信息, 所有企业微信消息链接页面均需要先调用此方法
  async weWorkInit(code, routeCompanyCode) {
    let data: UserResponse = {
      success: false,
      errorCode: '0001',
      errorMsg: '无法确定用户身份'
    };
    let wwxUserInfo;
    this.setAppName('weWork');
    await Http.post('/api/getWwxUserInfoByCode', { code }).then(response => {
      if (response.success) {
        wwxUserInfo = response.data;
      } else {
        data = response;
      }
    });

    if (!wwxUserInfo) {
      return data;
    }

    let { CorpId, UserId } = wwxUserInfo;
    //dev调试用
    //CorpId = 'a0002';
    //UserId = 'oLSoT5jlYuozG0YS1G0ODzspP2rc';
    let postbody = {
      wechatUserId: UserId,
      corpId: CorpId,
      apiPath: '/sysUser/loginByWechatUserId'
    };
    await Http.post('/api/user', postbody).then(response => {
      if (response.success) {
        userInfo = response.data.sysUser;
        companyList = response.data.companyList;
        this.setUserInfo(userInfo);
        this.setCompanyList(companyList);
        if (routeCompanyCode) {
          companyCode = routeCompanyCode;
          this.setCompanyCode(companyCode);
        }
        this.initDefaultCompany();
      }
      data = response;
    });
    if (companyList.length > 0) {
      await this.getMenuAuth();
    }
    if (companyCode === undefined) {
      data = { success: false, errorCode: '0002', errorMsg: '用户无默认公司' };
    }
    return data;
  },

  // 钉钉初始化登录信息, 所有钉钉消息链接页面均需要先调用此方法
  async dingTalkInit(corpId, code, routeCompanyCode) {
    this.setAppName('dingtalk');
    this.sendEvent({ fn: 'dingTalkInit', corpId: corpId, code: code });
    let data: UserResponse = {
      success: false,
      errorCode: '0001',
      errorMsg: '无法确定用户身份'
    };
    let dingUserInfo;
    await Http.post('/api/cloudCenter', {
      apiPath: '/public/dingtalk/getUserInfoByCode',
      code,
      corpId
    }).then(response => {
      if (response.success) {
        dingUserInfo = response.data;
      } else {
        data = response;
      }
    });

    if (!dingUserInfo) {
      return data;
    }

    let { unionid } = dingUserInfo;

    let postbody = {
      dingUnionId: unionid,
      dingCorpId: corpId,
      apiPath: '/sysUser/loginByDingUnionId'
    };
    await Http.post('/api/user', postbody).then(response => {
      if (response.success) {
        userInfo = response.data.sysUser;
        companyList = response.data.companyList;
        this.setUserInfo(userInfo);
        this.setCompanyList(companyList);
        if (routeCompanyCode) {
          companyCode = routeCompanyCode;
          this.setCompanyCode(companyCode);
        }
        this.initDefaultCompany();
      }
      data = response;
    });
    if (companyList.length > 0) {
      await this.getMenuAuth();
    }
    if (companyCode === undefined) {
      data = { success: false, errorCode: '0002', errorMsg: '用户无默认公司' };
    }
    return data;
  },

  //初始化用户和公司列表，钉钉Iot入口页会调用此方法
  async dingIotInit(queryParams) {
    let data: UserResponse = {
      success: false,
      errorCode: '0001',
      errorMsg: '无法确定用户身份'
    };
    let ssoData;
    await Http.post('/api/cloudCenter', {
      apiPath: '/third/dingIot/ssoLogin',
      ...queryParams
    }).then(response => {
      if (response.success) {
        ssoData = response.data;
      } else {
        data = response;
      }
    });

    if (ssoData) {
      await Http.post('/api/user', {
        apiPath: '/sysUser/loginByIot',
        ...ssoData
      }).then(response => {
        if (response.success) {
          this.setUserInfo(response.data.sysUser);
          this.setCompanyList(response.data.companyList);
          companyList = response.data.companyList;
          this.initDefaultCompany();
        }
        data = response;
      });
      if (companyList.length > 0) {
        await this.getMenuAuth();
      }
      if (companyCode === undefined) {
        data = {
          success: false,
          errorCode: '0002',
          errorMsg: '用户无默认公司'
        };
      }
    }

    return data;
  },

  setUserInfo(info) {
    userInfo = { ...info };
    Storage.setItem('userInfo', info);
  },

  getUserInfo() {
    return userInfo;
  },

  //获取最新用户及公司信息（冗余，纯获取数据，不作其他逻辑）
  async getUserInfoByToken() {
    let res;
    await Http.post('/api/user', {
      apiPath: '/sysUser/getNewUserInfoByToken'
    }).then(response => {
      if (response.success) {
        res = response.data;
      }
    });
    return res;
  },

  //获取菜单列表（纯菜单树，不带权限码）
  async queryTreeOnly() {
    let data: any;
    await Http.post('/api/user', { apiPath: '/sysMenu/queryTreeOnly' }).then(
      response => {
        if (response.success) {
          data = response.data;
        }
      }
    );

    return data;
  },

  //获取菜单的权限码
  async getMenuAuth() {
    let res = {};
    if (
      defaultCompany === undefined ||
      defaultCompany.companyCode === undefined
    ) {
      return res;
    }
    let postbody = {
      roleCode: defaultCompany.roleCode,
      userType: defaultCompany.userType,
      companyCode: defaultCompany.companyCode,
      apiPath: '/sysRole/getMenuAuthPayCodeAndSub'
    };
    await Http.post('/api/user', postbody).then(response => {
      if (response.success) {
        res = response.data;
        authCodeList = response.data.authCodeList || [];
        Storage.setItem('authCodeList', authCodeList);
      }
    });
    return res;
  },

  //根据权限码检查权限
  checkAuth(code) {
    if (typeof code === 'string') {
      return authCodeList.indexOf(code) > -1;
    } else if (Array.isArray(code)) {
      return code.some(item => authCodeList.indexOf(item) > -1);
    }
    return false;
  },

  //获取最新用户及公司信息
  async refreshUserInfo() {
    let data = {};
    await Http.post('/api/user', {
      apiPath: '/sysUser/getNewUserInfoByToken'
    }).then(response => {
      if (response.success) {
        data = response.data;
        userInfo = response.data.sysUser;
        companyList = response.data.companyList;
        this.setUserInfo(userInfo);
        this.setCompanyList(companyList);
        this.initDefaultCompany();
        this.getMenuAuth();
        this.queryTreeOnly();
      }
    });
    return data;
  },

  /**
   * 检查IP地址限制
   *
   * @description 1. 系统参数开启访问IP限制
   *              2. 岗位数据权限开启访问IP限制
   *              3. 管理员不受限制
   *
   * @param compCode
   * @returns isIpSafe ip是否安全
   */
  async checkIpLimit(compCode) {
    let isIpSafe: boolean = true; //为避免误报，默认都是true
    let postbody = {
      apiPath: '/archives/compParam/getIpLimit'
    };
    if (Util.isEmpty(compCode)) {
      return isIpSafe;
    }
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response && response.success && response.data === false) {
        isIpSafe = false;
      }
    });

    //跳转
    if (!isIpSafe) {
      window.location.href = '/mp/iplimit';
    }

    return isIpSafe;
  },

  sendEvent(params = {}) {
    let postbody = {
      action: 'dingding',
      userId: userInfo.id,
      ...params
    };
    // 发送异步和非阻塞请求，且不需要响应
    if (navigator.sendBeacon) {
      navigator.sendBeacon('/api/event', JSON.stringify(postbody));
    }
  }
};

export default User;
